import { Route } from "react-router-dom";
import { JobsCreatePage } from "pages/JobsCreatePage";
import { JobsPage } from "pages/JobsPage/JobsPage";
import { jobsCreatePath, jobsListPath } from "router/path";

export const JobsRoutes = [
  <Route key={jobsListPath} path={jobsListPath} element={<JobsPage />} />,
  <Route key={jobsCreatePath} path={jobsCreatePath} element={<JobsCreatePage />} />,
]
